import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import TopMenu from '../../contexts/TopMenu';
import '../../styles/ProductDetails.css';

function ProductDetails({ email, onLogout }) {
  const location = useLocation();
  const { product } = location.state || {};
  const [selectedVariant, setSelectedVariant] = useState(product?.variants?.[0]);
  const [selectedImage, setSelectedImage] = useState(product?.images?.[0]);

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div className="dashboard-root">
      <TopMenu pageTitle={product?.title || 'Product Details'} email={email} onLogout={onLogout} />
      <div className="dashboard-container">
        <div className="product-details-container">
          <div className="product-details">
            <div className="product-details-content">
              <div className="product-details-left">
                <div className="product-images">
                  <div className="main-image">
                    <img 
                      src={selectedImage?.url || product.images?.[0]?.url || '/placeholder-product.png'} 
                      alt={product.title}
                    />
                  </div>
                  <div className="image-thumbnails">
                    {product.images?.map((image) => (
                      <div 
                        key={image.id} 
                        className={`thumbnail ${selectedImage?.id === image.id ? 'selected' : ''}`}
                        onClick={() => setSelectedImage(image)}
                      >
                        <img src={image.url} alt={product.title} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="product-details-right">
                <div className="product-info-section">
                  <h2>Product Information</h2>
                  <div className="info-group">
                    <label>Title</label>
                    <div className="info-value">{product.title}</div>
                  </div>
                  <div className="info-group">
                    <label>Description</label>
                    <div className="info-value" dangerouslySetInnerHTML={{ __html: product.description_html }} />
                  </div>
                </div>

                <div className="product-variants-section">
                  <h2>Variants</h2>
                  <div className="variants-grid">
                    {product.variants?.map((variant) => (
                      <div 
                        key={variant.id}
                        className={`variant-card ${selectedVariant?.id === variant.id ? 'selected' : ''}`}
                        onClick={() => setSelectedVariant(variant)}
                      >
                        <h3>{variant.title}</h3>
                        <div className="variant-details">
                          <p>Price: ₹{variant.price}</p>
                          {variant.compare_at_price && (
                            <p className="compare-price">Compare at: ₹{variant.compare_at_price}</p>
                          )}
                          <p>SKU: {variant.sku || 'N/A'}</p>
                          <p>Stock: {variant.inventory_quantity}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="product-metadata-section">
                  <h2>Additional Details</h2>
                  <div className="metadata-grid">
                    <div className="info-group">
                      <label>Product Type</label>
                      <div className="info-value">{product.product_type}</div>
                    </div>
                    <div className="info-group">
                      <label>Vendor</label>
                      <div className="info-value">{product.vendor}</div>
                    </div>
                    <div className="info-group">
                      <label>Tags</label>
                      <div className="info-value tags-list">
                        {product.tags?.map((tag) => (
                          <span key={tag} className="tag">{tag}</span>
                        ))}
                      </div>
                    </div>
                    {product.metafields?.custom?.about_fabric && (
                      <div className="info-group">
                        <label>Fabric</label>
                        <div className="info-value">{product.metafields.custom.about_fabric}</div>
                      </div>
                    )}
                    {product.metafields?.custom?.washing_instructions && (
                      <div className="info-group">
                        <label>Care Instructions</label>
                        <div className="info-value">{product.metafields.custom.washing_instructions}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails; 